/**
 * 判断给定的字符串是否为有效的 JSON 字符串。
 *
 * @param str - 要判断的字符串。
 * @returns 如果字符串是有效的 JSON 字符串，则返回 true；否则返回 false。
 */
export function isJsonString(str: string): boolean {
  try {
    JSON.parse(str)
    return true
  }
  catch {
    return false
  }
}

/**
 * 将给定的字符串解析为 JSON 对象。
 * 如果字符串是有效的 JSON 字符串，则返回解析后的对象；
 * 否则返回默认值或原始字符串。
 *
 * @param obj - 要解析的字符串。
 * @param defaultValue - 默认值，如果字符串无法解析为 JSON 对象时使用。
 * @returns 解析后的 JSON 对象或默认值。
 */
export function JsonParse(obj: string, defaultValue?: unknown) {
  try {
    return isJsonString(obj) ? JSON.parse(obj) : defaultValue || obj
  }
  catch (error) {
    console.error('JsonParse error', error)
  }
}

/**
 * 深层序列化对象。
 * 递归地将给定的字符串解析为 JSON 对象，直到无法再解析为止。
 * 如果字符串是有效的 JSON 字符串，则返回解析后的对象；
 * 否则返回默认值或原始字符串。
 *
 * @param obj - 要解析的字符串。
 * @param defaultValue - 默认值，如果字符串无法解析为 JSON 对象时使用。
 * @returns 解析后的 JSON 对象或默认值。
 */
export function deepJsonParse(obj: string, defaultValue?: unknown) {
  let data = obj
  let parseCount = 0
  try {
    while (isJsonString(data)) {
      data = JSON.parse(data)
      parseCount++
    }
    return parseCount > 0 ? data : defaultValue || obj
  }
  catch (error) {
    console.error('deepJsonParse error', error)
    return defaultValue || obj
  }
}

/**
 * 格式化 JSON 字符串，获取对象。
 *
 * @param obj - 要格式化的字符串或对象。
 * @returns 格式化后的 JSON 字符串或原始对象。
 */
export function JsonString(obj: string | object) {
  try {
    return typeof obj === 'string' ? obj : JSON.stringify(obj)
  }
  catch (error) {
    console.error('JsonString error', error)
  }
}
